import React from 'react';
import { Control } from 'react-hook-form';

import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Icons } from '@/components/icons';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import MyTenantSelector from '@/components/QuerySelectors/MyTenantSelector';

import { OnboardingSchema } from './schema';

interface IProps {
  control: Control<OnboardingSchema>;
  onSubmit: (event: React.SyntheticEvent) => void;
  isLoading: boolean;
}

const OnboardingView: React.FC<IProps> = ({ control, onSubmit, isLoading }) => (
  <div className="lg:p-8 mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
    <div className="flex flex-col space-y-2 text-center">
      <h1 className="text-2xl font-semibold tracking-tight">Onboarding</h1>
      <p className="text-sm text-muted-foreground">
        Selecione uma organização para continuar
      </p>
    </div>
    <div className={cn('grid gap-6')}>
      <form onSubmit={onSubmit}>
        <div className="grid gap-6">
          <div className="grid gap-4">
            <FormField
              control={control}
              name="organization"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Organização</FormLabel>
                  <FormControl>
                    <MyTenantSelector
                      value={field.value}
                      onChange={field.onChange}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>

          <Button disabled={isLoading}>
            {isLoading && (
              <Icons.spinner className="mr-2 h-4 w-4 animate-spin" />
            )}
            Continuar
          </Button>
        </div>
      </form>
    </div>
  </div>
);

export default OnboardingView;
